// extracted by mini-css-extract-plugin
module.exports = {"Label":"SupplierCheckDetails_Label__2XFvi"};